import styled from "@emotion/styled";
import theme from "../theme";
import Footer from "./footer";
import TopNav from "./TopNav";
import { ReactNode } from "react";
import { useWindowSize } from "@reactuses/core";
import { MobileNav } from "./mobileSize/MobileNav";
import { Breadcrumb } from "./Breadcrumbs";
//import { DailyWarning } from "./DailyWarning";

const { md } = theme.screen;

type Prop = {
  children: ReactNode;
  withoutHeader?: boolean;
  withoutFooter?: boolean;
  subHeader?: ReactNode;
  bodyHeight?: string;
  bodyMinHeight?: string;
  bodyPaddingBottom?: string;
  withoutBody?: boolean;
  withBreadcrumb?: boolean;
  isFull?: boolean; // 화면 가득 채움
};

/**
 * 페이지에 기본 레이아웃 컴포넌트
 *
 * @param children: 페이지 컨텐츠
 * @param subHeader?: 서브헤더 컴포넌트
 * @param bodyHeight?: 바디 영역 높이. 기본값 - calc(100vh - 227px)
 * @param bodyMinHeight?: 바디 영역 높이. 기본값 - 990px
 * @param bodyPaddingBottom?: 바디 패딩 바텀값. 페이지네이션 적용되는 페이지에서 사용
 * @param withoutHeader?: 헤더 제외하기
 * @param withoutFooter?: 풋터 제외하기
 * @param withoutBody?: 바디 영역 제외하기 (바디 셀프로 적용할 시)
 * @param withBreadcrumb?: 브래드크럼 사용 시
 *
 */

export const PageLayout = ({
  children,
  subHeader,
  bodyHeight,
  bodyMinHeight,
  bodyPaddingBottom,
  withoutHeader,
  withoutFooter,
  withoutBody,
  withBreadcrumb,
  isFull = false,
}: Prop) => {
  const { width } = useWindowSize();
  return (
    <Wrapper id="page-layout" $isFull={isFull}>
      {/* {!withoutHeader && (width <= md ? <MobileNav /> : <TopNav />)} */}
      {!withoutHeader && (width <= md ? <MobileNav /> : <TopNav />)}
      {withBreadcrumb && <Breadcrumb />}
      {subHeader && subHeader}
      {!withoutBody && (
        <Body
          $bodyHeight={bodyHeight}
          $bodyMinHeight={bodyMinHeight}
          $bodyPaddingBottom={bodyPaddingBottom}
        >
          {children}
        </Body>
      )}
      {withoutBody && !isFull && children}
      {withoutBody && isFull && children}
      {!withoutFooter && <Footer />}

      {/* 금일 점검 요망 농기계 목록 플로팅 버튼
          홈화면이랑 관제화면은 각 페이지에 추가 */}
      {/* <DailyWarning /> */}
    </Wrapper>
  );
};

const Wrapper = styled.div<{ $isFull: boolean }>`
  background-color: ${theme.color.white};
  position: relative;

  @media (max-width: ${md}px) {
    max-width: none;
    min-width: none;
    padding: 0px;
  }

  @media (min-width: ${md + 1}px) {
    padding: ${({ $isFull }) => ($isFull ? "0px" : "0px 30px 0px 30px")};
    max-width: ${({ $isFull }) => ($isFull ? "100vw" : "1440px")};
    min-width: ${({ $isFull }) => ($isFull ? "100vw" : "1440px")};
    margin: 0 auto;
  }
`;

const Body = styled.div<{
  $bodyHeight: string | undefined;
  $bodyMinHeight: string | undefined;
  $bodyPaddingBottom?: string;
}>`
  background: ${theme.color.neutral_50};
  width: 100%;
  overflow-y: auto;
  overflow-x: auto;
  display: flex;
  flex-direction: column;

  @media (max-width: ${md}px) {
    padding: 16px;
    padding-bottom: ${({ $bodyPaddingBottom }) =>
      $bodyPaddingBottom ? $bodyPaddingBottom : "16px"};
    min-height: calc(var(--vh, 1vh) * 100 - 50px);
    width: 100vw;
    min-width: 320px;
  }

  @media (min-width: ${md + 1}px) {
    height: ${({ $bodyHeight }) =>
      $bodyHeight ? $bodyHeight : `calc(var(--vh, 1vh) * 100 - 227px)`};
    min-height: ${({ $bodyMinHeight }) =>
      $bodyMinHeight ? $bodyMinHeight : `990px`};
    padding: 40px 30px 30px 30px;
    border-radius: 20px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
    margin-bottom: 20px;
  }
`;
